// extracted by mini-css-extract-plugin
module.exports = {"cls1":"index-HeroLink-module--cls1--2d2aM","cls2":"index-HeroLink-module--cls2--2k2Vr index-HeroLink-module--cls1--2d2aM"};